<template>
  <NavItem :item="item" />
</template>

<script>
import { InboxEvent } from '@/modules/inbox/constants/InboxEvent';
import NavItemComponent from '/@/modules/core/nav/components/NavItem.vue';
import { NavItem } from '/@/modules/core/nav/models/NavItem';
import InboxConversationService from '/@/modules/inbox/services/InboxConversationService';
import { state } from '/@/modules/core/app/helpers/store';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'InboxNavItem',
  components: { NavItem: NavItemComponent },
  props: {
    item: {
      type: NavItem,
      required: true
    }
  },
  events() {
    return {
      [InboxEvent.ON_UNREAD_CHANGED]: this.setText
    };
  },
  computed: {
    unreadConversations() {
      return state.inbox.unreadConversations;
    }
  },
  methods: {
    setText(conversations) {
      this.item.setBadgeText(conversations?.length ?? null);
    },
    async loadUnreadConversationsBadge() {
      const conversations = await InboxConversationService.getUnreadConversations();
      this.setText(conversations);
    }
  },
  mounted() {
    this.loadUnreadConversationsBadge();
  },
  watch: {
    unreadConversations(unreadConversations) {
      this.setText(unreadConversations);
    }
  }
};
</script>

<style scoped>
:deep(.tag) {
  opacity: 0;
  animation-name: slide-fade-in-bu;
  animation-duration: 0.3s;
  animation-delay: 0;
  animation-fill-mode: forwards;
  transform: translateY(10px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}
</style>
